import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getInvoicesDataView } from "@insite/client-framework/Store/Data/Invoices/InvoicesSelectors";
import Typography from "@insite/mobius/Typography/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    invoicesDataView: getInvoicesDataView(state, state.pages.invoiceHistory.getInvoicesParameter),
});

type Props = ReturnType<typeof mapStateToProps>;

export interface InvoiceHistoryTableStyles {
    label: InjectableCss;
    value: InjectableCss;
}

export const styles: InvoiceHistoryTableStyles = {
    label: {
        css: css`
            width: 250px;
            font-size: 15px;
            font-weight: 600;
        `,
    },
    value: {},
};

const FilteredTotalInvoices = ({ invoicesDataView }: Props) => {
    const tempInvoicesDataView : any = invoicesDataView;

    if (!tempInvoicesDataView) {
        return null;
    }

    if (tempInvoicesDataView?.properties?.filteredInvoicesTotal !== undefined) {
        return (
            <>
                <Typography {...styles.label}>{siteMessage("TotalOfInvoices")}</Typography>

                <Typography {...styles.value}>
                    {
                        tempInvoicesDataView?.properties?.filteredInvoicesTotal
                    }
                </Typography>
            </>
        );
    }

    return <></>;
};

export default connect(mapStateToProps)(FilteredTotalInvoices);
